import {AddressProps} from 'modules/addresses/types';
import {OrderAddressProps} from 'modules/orders/types';

export default (
  address: AddressProps | OrderAddressProps,
  includeCityAndState = true,
) => {
  const {name, street, city, state, number, neighborhood} = address;

  let formattedAddress = '';

  // if (name) formattedAddress = `${name} - `;
  if (street)
    formattedAddress
      ? (formattedAddress += street)
      : (formattedAddress = street);
  if (number) formattedAddress += `, ${number}`;
  if (neighborhood && !formattedAddress)
    formattedAddress =
      typeof neighborhood === 'object' ? neighborhood.name : neighborhood;
  if (neighborhood && formattedAddress)
    formattedAddress += ` - ${
      typeof neighborhood === 'object' ? neighborhood.name : neighborhood
    }`;
  if (includeCityAndState && city && !formattedAddress)
    formattedAddress = `${
      typeof city === 'object' ? city.name : city
    } - ${state}`;
  if (includeCityAndState && city && formattedAddress)
    formattedAddress += ` - ${
      typeof city === 'object' ? city.name : city
    } - ${state}`;

  return formattedAddress;
};
